import styled from "styled-components";
import Box from "../../Components/Box";

const StyledDrawerBackButton = styled(Box)`


    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    cursor: pointer;
    border-radius: 8px;
    background-color: black;
    min-height: 50px;
    width: 50px;
    position: relative;
    top: 4rem;
    right: 25px;
    border: solid 1px white;
    transition: 0.3s ease;
  


`

export default StyledDrawerBackButton